import axios from 'axios';
import config from '../common/config';

export default {
  fetchUserExtraInformationByRideID(token, rideID) {
    return axios.get(`${config.config.ROOT_URL}/user_info_from_ride_id_api/${rideID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  fetchCurrentUserProfile(token) {
    return axios.get(`${config.config.ROOT_URL}/current_user_profile_api`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  updateUserProfile(token, profileData) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(profileData));
    
    return axios.post(`${config.config.ROOT_URL}/update_user_profile_api`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'
      }
    });
  },
};
